module.exports = __webpack_public_path__ + "static/img/ttto-thumbnail.d08c13c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ttto-thumbnail.jpg
// module id = 80
// module chunks = 2